import { HttpErrorResponse } from "@angular/common/http";
import {
  AddLearningResourcesDto,
  LearningResource,
  LearningResourceItem,
  RemoveLearningResourcesDto,
  UpdateActivityDueDateDto,
  UpdateLearningResourceDto,
} from "src/app/_models/LearningResource";
import { MessageResultDto } from "src/app/_models/MessageResultDto";

export interface LearningResourcesState {
  loading: boolean;
  result: LearningResource;
  moduleTypes: string[];
  updateDto: UpdateLearningResourceDto;
  addDto: AddLearningResourcesDto;
  updateActivityDueDateDto: UpdateActivityDueDateDto;
  removeDto: RemoveLearningResourcesDto;
  loadLearningResourceItems: boolean;
  learningResourceItems: LearningResourceItem[];
  error: HttpErrorResponse;
  messageResult: MessageResultDto;
}

export const initialLearningResourceState: LearningResourcesState = {
  loading: false,
  result: null,
  moduleTypes: null,
  updateDto: null,
  addDto: null,
  updateActivityDueDateDto: null,
  removeDto: null,
  loadLearningResourceItems: false,
  learningResourceItems: null,
  error: null,
  messageResult: null,
};
